import QRCode from 'react-qr-code'
import { useTranslation } from '../hooks/useTranslation'

export default function ReviewCard({ googlePlaceId }: { googlePlaceId: string }) {
  const { t } = useTranslation()
  const url = `https://search.google.com/local/writereview?placeid=${googlePlaceId}`

  return (
    <div className="z-[1] flex w-full flex-col items-center">
      <div className="flex w-full flex-col items-center gap-[clamp(5px,0.9vh,10px)] rounded-2xl border border-black/[0.08] bg-black/[0.03] px-[clamp(12px,2vw,24px)] py-[clamp(10px,1.5vh,20px)]">
        <div className="flex items-center gap-2.5">
          <svg className="h-[22px] w-[22px] shrink-0" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
          </svg>
          <div className="font-volte text-[clamp(0.85rem,1.8vh,1.1rem)] leading-tight text-text-hi">
            {t('loved-your-visit')}
          </div>
        </div>
        <div className="flex gap-1 text-accent">
          {[0, 1, 2, 3, 4].map((i) => (
            <span key={i} className="text-[clamp(0.9rem,1.6vh,1.2rem)]">
              ★
            </span>
          ))}
        </div>
        <div className="text-center text-[clamp(0.6rem,1.2vh,0.75rem)] leading-normal text-text-mid">
          {t('share-your-experience')}
        </div>
        <div className="mb-4 flex h-[clamp(90px,14vh,144px)] w-[clamp(90px,14vh,144px)] items-center justify-center rounded-[10px] bg-white p-[7px] shadow-[0_4px_24px_rgba(0,0,0,0.25)]">
          <QRCode value={url} className="h-full w-full" style={{ height: '100%', width: '100%' }} />
        </div>
      </div>
    </div>
  )
}
